<template>
  <div class="main">
    <div class="settings-wrapper">
      <div class="settings-container">
        <button class="back-link" @click="updateSettings(true)"><img src="@/assets/images/back.svg"> Zurück</button>
        <h1>Einstellungen</h1>
        <div class="settings-list">
          <div class="single-setting">
            <span class="setting-label">Chat-Lesebestätigung</span>
            <input type="checkbox" v-model="messagesSeenOn" @change="updateSettings()">
          </div>
          <p><router-link to="/privacy">Datenschutzerklärung</router-link></p>
          <div class="account-bottom">
            <p class="account-email">Account: <b>{{ accountEmail }}</b></p>
            <button class="logout" @click="logout" v-if="!details_expanded">Logout</button>
          </div>
        </div>
      </div>
      <LoadingSpinner v-if="submitting"></LoadingSpinner>      
    </div>
  </div>
</template>

<script>
import AuthService from '@/services/AuthService.js';
import LoadingSpinner from "@/components/LoadingSpinner.vue";
export default {
  "name": "SettingsView",
  data() {
    return {
      user: null,
      isAdmin: false,
      accountEmail: null,
      submitting: false,
      messagesSeenOn: false
    }
  },
  components: {
    LoadingSpinner
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
    async updateSettings(redirect = false) {
      await AuthService.updateSettings({messagesSeenOn: this.messagesSeenOn})
      if(redirect) this.$router.push("/account")
    }
  },
  async beforeCreate() {
    if (!this.$store.getters.isLoggedIn) {
      this.$router.push('/login');
    }
  },
  async mounted() {
    try {
      this.msg = await AuthService.getUser()
      this.isAdmin = !!this.msg.msg[0].isAdmin;
      this.accountEmail = this.msg.msg[0].email
      this.user = this.msg.msg[0]
      this.messagesSeenOn = !!this.msg.msg[0].messages_seen_on
    } catch(e){
      console.error(e)
    }
  }
}
</script>
<style scoped>
.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  padding: 20px;
}

h1 {
  font-size: 2.2rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  margin: 24px 0;
  color: var(--text-main);
}

.settings-wrapper {
  width: 100%;
  max-width: var(--max-width);
}

.settings-container {
  background: white;
  border-radius: var(--radius-xl);
  padding: 32px;
  box-shadow: var(--shadow-strong);
  display: flex;
  flex-direction: column;
}

.settings-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.single-setting {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border-color);
}

.setting-label {
  font-size: 1.1rem;
  font-weight: 600;
}

.settings-list input[type=checkbox] {
  width: 44px;
  height: 24px;
  -webkit-appearance: none;
  appearance: none;
  background: #E9E9EB;
  border-radius: 12px;
  position: relative;
  cursor: pointer;
  transition: background 0.2s ease;
}

.settings-list input[type=checkbox]:checked {
  background: #34C759;
}

.settings-list input[type=checkbox]::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background: white;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  transition: transform 0.2s ease;
}

.settings-list input[type=checkbox]:checked::after {
  transform: translateX(20px);
}

.account-bottom {
  margin-top: 24px;
  text-align: left;
}

.account-email {
  font-size: 0.95rem;
  color: var(--text-secondary);
  margin-bottom: 16px;
}

button.logout {
  width: 100%;
  padding: 14px;
  background: #FFF0F0;
  color: #FF3B30;
  border: none;
  border-radius: var(--radius-m);
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
}

.back-link {
  background: none;
  border: none;
  color: var(--primary-color);
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  padding: 0;
  margin-bottom: 20px;
  cursor: pointer;
}

.back-link img {
  width: 16px;
  filter: invert(34%) sepia(87%) saturate(5451%) hue-rotate(200deg) brightness(101%) contrast(105%);
}

p a {
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 600;
}
</style>
